import { useEffect, useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import TagWall from './components/TagWall';
import FeedSection from './components/FeedSection';
import EvidenceSection from './components/EvidenceSection';
import MediaSection from './components/MediaSection';
import RankSection from './components/RankSection';
import ZonesSection from './components/ZonesSection';
import SiteFooter from './components/SiteFooter';

function BackTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 900);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  if (!show) return null;
  return (
    <a
      href="#top"
      aria-label="回到顶部"
      className="fixed bottom-6 right-6 z-40 grid h-11 w-11 cursor-pointer place-items-center rounded-full bg-ink-950 text-gold-300 shadow-lg transition-colors hover:bg-flame-600 hover:text-white"
    >
      <i className="ri-arrow-up-line text-lg" />
    </a>
  );
}

export default function Home() {
  return (
    <div className="min-h-screen bg-paper-50 text-ink-950">
      <Header />
      <main>
        <Hero />
        <TagWall />
        <FeedSection />
        <EvidenceSection />
        <MediaSection />
        <RankSection />
        <ZonesSection />
      </main>
      <SiteFooter />
      <BackTop />
    </div>
  );
}